<template>
  <BaseDialogForm :is-edit="isEdit">
    <template v-slot:toggle="{ on }">
      <v-btn v-if="!isEdit" color="primary" v-on="on" @click.stop="onOpen()">
        <v-icon left>
          add_box
        </v-icon>
        New Ticket
      </v-btn>
      <v-btn v-else icon v-on="on" color="primary" @click.stop="onOpen()">
        <v-icon>
          edit
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      <h2 v-if="isEdit">Edit {{ instance.name }}</h2>
      <h2 v-else>Make A New Ticket</h2>
    </template>
    <template v-slot:content>
      <v-form v-model="$v.valid" @submit.prevent="submit">
        <v-text-field
          v-model.trim="$v.formdata.name.$model"
          :error-messages="nameErrors"
          label="Ticket Name"
          type="text"
          :counter="formdata.nameCounter"
          hint="Unique Ticket Name"
          :prepend-icon="formdata.nameIcon"
          @input="$v.formdata.name.$touch()"
          @blur="$v.formdata.name.$touch()"
        />
        <v-textarea
          v-model="formdata.notes"
          label="Ticket Notes"
          :prepend-icon="formdata.notesIcon"
        >
        </v-textarea>
        <v-text-field
          v-model="$v.formdata.samples.$model"
          type="number"
          label="Sample Count"
          :error-messages="samplesErrors"
          hint="The number of samples in this ticket"
          :prepend-icon="formdata.samplesIcon"
          @input="$v.formdata.samples.$touch()"
          @blur="$v.formdata.samples.$touch()"
        >
        </v-text-field>
        <v-autocomplete
          v-model="$v.formdata.batch_ids.$model"
          label="Batch Selection"
          :error-messages="batchErrors"
          multiple
          chips
          prepend-icon="fas fa-cube"
          :items="batches"
          :item-text="item => item.forgeID + ' - ' + item.name"
          item-value="id"
          hint="Select batches for this ticket"
          @input="$v.formdata.batch_ids.$touch()"
          @blur="$v.formdata.batch_ids.$touch()"
          :loading="loading"
        />
        <v-switch
          v-model="formdata.rush"
          label="Rush Ticket?"
          :prepend-icon="formdata.rushIcon"
          hint="Move this ticket to the front of the list"
        >
        </v-switch>
      </v-form>
    </template>

    <template v-slot:actions="{ close }">
      <v-btn
        :disabled="$v.$invalid"
        color="primary"
        @click="
          submit();
          close();
        "
      >
        <v-icon dark left>
          fas fa-save
        </v-icon>
        Save
      </v-btn>
    </template>
  </BaseDialogForm>
</template>

<script>
import Batch from "../../models/Batch";
import { validationMixin } from "vuelidate";
import { handleErrors } from "../../services/formErrors";
import { BatchTicket } from "../../models/Ticket";
import BaseDialogForm from "../Base/BaseDialogForm";
export default {
  name: "QualityCoatedTicketForm",
  components: { BaseDialogForm },
  mixins: [validationMixin],
  validations: BatchTicket.validations,
  props: {
    instance: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      formdata: new BatchTicket(this.instance),
      loading: true
    };
  },
  computed: {
    batches() {
      return Batch.query().orderBy('forgeID').get();
    },
    nameErrors() {
      return handleErrors("formdata", "name", this);
    },
    samplesErrors() {
      return handleErrors("formdata", "samples", this);
    },
    batchErrors() {
      return handleErrors("formdata", "batch_ids", this);
    }
  },
  methods: {
    onOpen() {
      Batch.$fetchActive().then(() => {
        this.loading = false;
      });
    },
    submit() {
      this.$v.$touch();
      if (this.isEdit) {
        BatchTicket.$put(this.instance.id, this.formdata.toUpdatePayload())
      } else {
        BatchTicket.$post(this.formdata.toCreatePayload());
        this.clear();
      }
    },
    clear() {
      this.formdata = new BatchTicket();
      this.$v.$reset();
    }
  }
};
</script>
